ajaxWithSpinner = function (params) {
  let spinner = $(".ajax-spinner");
  spinner.show();

  successCallback = params.success;
  params.success = function (data) {
    spinner.hide();
    if (successCallback)
      successCallback(data);
  }

  $.ajax(params);
}
